import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import ReactTable, { Column } from 'react-table';

import { RouteDefinitions, getRoute } from '@common/route-definitions';
import { ContractSimpleViewModel } from '@models/Contract';

export interface RelatedContractsComponentProperties extends RouteComponentProps<{ id: number }> {
  readonly contractId?: number;
  readonly relatedContractsLoading: boolean;
  readonly relatedContractsPageCount: number;
  readonly relatedContractsPageNumber: number;
  readonly relatedContractsPageSize: number;
  readonly relatedContractsResults: ContractSimpleViewModel[];

  readonly getRelatedContracts: (id: number, pageNumber: number, pageSize: number) => void;
}

export class RelatedContractsComponent extends React.Component<RelatedContractsComponentProperties> {
  render() {
    const columns: Column[] = [
      {
        accessor: (contract: ContractSimpleViewModel) =>
          contract && (
            <Link
              to={{
                pathname: getRoute(RouteDefinitions.contract.Details, {
                  id: contract.id
                }),
                state: { viewOnly: true }
              }}
            >
              {contract.number}
            </Link>
          ),
        id: 'ContractNumber',
        Header: 'Contract #',
        sortable: false
      },
      {
        accessor: (d: ContractSimpleViewModel) => (d.contractStatus ? d.contractStatus.value : ''),
        id: 'contractStatus',
        Header: 'Contract Status',
        sortable: false
      },
      {
        accessor: (d: ContractSimpleViewModel) => (d.resoldRelationship ? d.resoldRelationship : 'N/A'),
        id: 'resoldRelationship',
        Header: 'Relationship to Contract',
        sortable: false
      }
    ];

    return (
      <>
        <h3>Related Contracts</h3>

        <div className="col-md-12">
          <ReactTable
            onPageChange={() => {
              Array.from(document.getElementsByClassName('rt-tbody')).forEach(element => {
                element.scrollTop = 0;
              });
            }}
            className="-striped -highlight"
            columns={columns}
            data={this.props.relatedContractsResults}
            defaultPageSize={10}
            loading={this.props.relatedContractsLoading}
            manual={true}
            onFetchData={this.handleFetchData}
            pages={this.props.relatedContractsPageCount}
          />
        </div>
      </>
    );
  }

  private handleFetchData = (state: { page: number; pageSize: number }): void => {
    this.props.getRelatedContracts(this.props.contractId ? this.props.contractId : 0, state.page + 1, state.pageSize);
  };
}



// WEBPACK FOOTER //
// ./src/contract/_components/related-contracts/related-contracts.component.tsx